module.exports = __webpack_public_path__ + "img/1.25a6f53.png";